import React from 'react';
import { NavLink, Routes, Route, Navigate } from 'react-router-dom';

import AdminProducts from './AdminProducts';
import AdminOrders from './AdminOrders';
import AdminUsers from './AdminUsers';
import AdminContent from './AdminContent';

import './AdminDashboard.css';

function AdminDashboard() {
  const linkClass = ({ isActive }) =>
    `admin-dashboard__nav-btn${isActive ? ' admin-dashboard__nav-btn--active' : ''}`;

  return (
    <div className="admin-dashboard">
      <header className="admin-dashboard__header">
        <h2>Tableau de bord administrateur</h2>
        <p>Gérez le catalogue, suivez les commandes et contrôlez les accès utilisateurs.</p>
      </header>

      <nav className="admin-dashboard__nav">
        <NavLink to="products" className={linkClass} end>
          Gestion des produits
        </NavLink>
        <NavLink to="orders" className={linkClass}>
          Gestion des commandes
        </NavLink>
        <NavLink to="users" className={linkClass}>
          Gestion des utilisateurs
        </NavLink>
        <NavLink to="content" className={linkClass}>
          Gestion du contenu
        </NavLink>
      </nav>

      <section className="admin-dashboard__panel">
        <Routes>
          <Route index element={<Navigate to="products" replace />} />
          <Route path="products" element={<AdminProducts />} />
          <Route path="orders" element={<AdminOrders />} />
          <Route path="users" element={<AdminUsers />} />
          <Route path="content" element={<AdminContent />} />
        </Routes>
      </section>
    </div>
  );
}

export default AdminDashboard;
